import * as S from './DSOFooter.styles';

const FOOTER_LINKS = [
  {
    label: 'Privacy',
    href: 'https://www.invisalign.com/privacy-policy',
  },
  {
    label: 'Terms of Use',
    href: 'https://www.invisalign.com/terms-of-use',
  },
  {
    label: 'Software Agreement',
    href: 'https://assets.ctfassets.net/71gql6049r0g/2EPwvT5K1uwzdUIia48okH/85fda85bb43cd350bb979e6566636e60/General_Software_Agreement.pdf',
  },
];

const DSOFooter = () => {
  return (
    <S.FooterContainer>
      <S.LinksRow>
        <S.CopyrightText>
          &copy; Align Technology, Inc. All rights reserved.
        </S.CopyrightText>
        {FOOTER_LINKS.map(link => (
          <S.FooterLink
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noreferrer"
          >
            {link.label}
          </S.FooterLink>
        ))}
      </S.LinksRow>
      <S.LinksRow>
        <S.FooterLink id="teconsent" />
      </S.LinksRow>
    </S.FooterContainer>
  );
};

export default DSOFooter;
